module.exports = __webpack_public_path__ + "img/9.561abb6b.png";